"use client";

import React from "react";
import { Autocomplete, Box, Button, TextField, Typography } from "@mui/material";
import IndeterminateCheckbox from "@/app/(user)/koleksi/IndeterminateCheckbox";
import RangeSlider from "@/app/(user)/koleksi/RangeSlider";

interface FilterConfigurationBoxProps {
  buttonIsActive: {
    relevan: boolean;
    terbaru: boolean;
    banyakDibaca: boolean
  };
  // setButtonIsActive: (value: {
  //   relevan?: boolean;
  //   terbaru?: boolean;
  //   banyak_dibaca?: boolean
  // }) => void;
  setButtonIsActive: React.Dispatch<React.SetStateAction<{
    relevan: boolean;
    terbaru: boolean;
    banyakDibaca: boolean
  }>>;
  jenisPustaka: {
    id: string;
    label: string
  }[];
  jenisPustakaSelected: {
    id: string;
    label: string
  };
  setJenisPustakaSelected: (value: {
    id: string;
    label: string
  }) => void;
  klasifikasiSelected: string[];
  setKlasifikasiSelected: (value: string[]) => void;
  klasifikasiList: {
    id: string;
    nama: string
  }[] | null;
  setKlasifikasiList: (value: {
    id: string;
    nama: string
  }[] | null) => void;
  rangeTahun: [number, number];
  setRangeTahun: (value: [number, number]) => void;
  onApplyFilter?: () => void;
}

const FilterConfigurationBox: React.FC<FilterConfigurationBoxProps> = ({
  buttonIsActive,
  setButtonIsActive,
  jenisPustaka: jenis_pustaka,
  jenisPustakaSelected,
  setJenisPustakaSelected,
  klasifikasiSelected,
  setKlasifikasiSelected,
  klasifikasiList,
  setKlasifikasiList,
  rangeTahun,
  setRangeTahun,
  onApplyFilter
}) => {
  const handleClickUrutan = (value: string) => {
    setButtonIsActive((prevState) => ({
      relevan: value === "relevan",
      terbaru: value === "terbaru",
      banyakDibaca: value === "banyak_dibaca",
    }));
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "12px",
          marginBottom: "3px"
        }}
        variant="subtitle2">
        Urutkan
        Berdasarkan
      </Typography>
      <Box
        sx={{
          borderRadius: "10px",
          width: "100%",
          display: "grid",
          gridTemplateColumns: "auto auto auto"
        }}
      >
        <Button
          size="small"
          color={buttonIsActive.relevan ? "primary" : "inherit"}
          variant="contained"
          onClick={() => handleClickUrutan("relevan")}
          sx={{
            borderRadius: "10px 0 0 10px"
          }}
        >
          Relevansi
        </Button>
        <Button
          size="small"
          color={buttonIsActive.terbaru ? "primary" : "inherit"}
          variant="contained"
          onClick={() => handleClickUrutan("terbaru")}
          sx={{
            borderRadius: "0"
          }}
        >
          Terbaru
        </Button>
        <Button
          size="small"
          color={buttonIsActive.banyakDibaca ? "primary" : "inherit"}
          variant="contained"
          onClick={() => handleClickUrutan("banyak_dibaca")}
          sx={{
            borderRadius: "0 10px 10px 0"
          }}
        >
          Paling
          Banyak
          Dibaca
        </Button>
      </Box>
      <Typography
        sx={{
          fontSize: "12px",
          marginTop: "1.5rem",
          marginBottom: "3px"
        }}
        variant="subtitle2"
      >
        Kategori
        Bahan
        Pustaka
      </Typography>
      <Autocomplete
        value={jenisPustakaSelected}
        onChange={(event, newValue) => {
          if (newValue) {
            setJenisPustakaSelected(newValue);
          }
        }}
        size="small"
        disablePortal
        id="combo-box-demo"
        options={jenis_pustaka}
        sx={{ width: "100%" }}
        renderInput={(params) =>
          <TextField {...params} />}
      />
      <Box
        sx={{ marginTop: "1.5rem" }}>
        <IndeterminateCheckbox
          jenisPustakaSelected={jenisPustakaSelected}
          klasifikasiSelected={klasifikasiSelected}
          setKlasifikasiSelected={setKlasifikasiSelected}
          klasifikasiList={klasifikasiList}
          setKlasifikasiList={setKlasifikasiList}
        />
      </Box>
      <Typography
        sx={{
          fontSize: "12px",
          marginTop: "1.5rem"
        }}
        variant="subtitle2">
        Tahun
      </Typography>
      <RangeSlider
        rangeTahun={rangeTahun}
        setRangeTahun={setRangeTahun}/>
      {onApplyFilter && (
        <Button
          size="small"
          color="primary"
          variant="contained"
          sx={{ marginTop: "1.5rem" }}
          onClick={onApplyFilter}
        >
          Terapkan
        </Button>
      )}
    </Box>
  );
};

export default FilterConfigurationBox;
